const limits = {
  bulkDelete: 20,
};

export default limits;
